<template lang="html">
  <div id="login-page-container" class="uk-flex uk-flex-middle">
    <div class="uk-width uk-flex uk-flex-wrap uk-flex-center">
      <header class="uk-width uk-text-center uk-text-middle">
        <img :src="config.logo_url" alt="Logo" />
      </header>
      <div id="login" class="uk-section uk-section-primary uk-light uk-width-1-2@m">
        <div class="uk-container">
          <h3 style="text-align:center;">
            Resetowanie hasła
          </h3>
            <fieldset class="uk-fieldset">
              {{ info }}
            </fieldset>
        </div>
      </div>
      </div>

  </div>
</template>

<script>
export default {
  data () {
    return {
      'hash': '',
      'info': ''
    }
  },
  computed: {
    config () {
      return this.$parent.config
    }
  },
  mounted: function () {
    this.hash = this.$route.params.hash
    this.info = 'Dziękujemy. Nowe hasło zostanie wysłane do Ciebie przez SMS.'
    var ResetPassMetod = {'input': {'hash': this.hash}}
    this.$http.post('/api.php?url=ResetPass', ResetPassMetod, {headers: {'Content-Type': 'application/json'}}).then((response) => {
      this.info = 'Dziękujemy. Nowe hasło zostanie wysłane do Ciebie przez SMS.'
    }).catch((errors) => {
      this.info = 'Coś poszło nie tak...'
    })
  }
}
</script>

<style lang="sass" scoped>

  $small-break: 960px

  .error
    display: none
    background: rgba(232, 23, 23, 0.9)
    padding: 10px

    .message
      font-weight: 400 !important

  #login-page-container
    max-width: 960px
    height: calc(100% - 75px)
    margin: 0 auto
    padding: 0 10px

    @media screen and (max-width: $small-break)
      display: block

  #login *, #register *
    font-weight: 300

  #login
    @media screen and (max-width: $small-break)
      margin-bottom: 20px

  header
    position: absolute
    top: 20px
    height: 110px
    width: 300px
    color:

    @media screen and (max-width: $small-break)
      position: relative

</style>



// WEBPACK FOOTER //
// Resetpass.vue?4a82428d